function Honduras({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1342)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M16 32C22.3433 32 27.8244 28.3085 30.4124 22.9565H1.58765C4.17565 28.3085 9.65664 32 16 32Z" fill="#338AF3"/>
        <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0V0Z" fill="#338AF3"/>
        <path d="M9.8466 10.4348L10.3646 12.0291H12.0409L10.6848 13.0144L11.2028 14.6087L9.8466 13.6234L8.49035 14.6087L9.00841 13.0144L7.65222 12.0291H9.32853L9.8466 10.4348Z" fill="#338AF3"/>
        <path d="M9.8466 17.3914L10.3646 18.9857H12.0409L10.6848 19.971L11.2028 21.5652L9.8466 20.5799L8.49035 21.5652L9.00841 19.971L7.65222 18.9857H9.32853L9.8466 17.3914Z" fill="#338AF3"/>
        <path d="M22.1535 10.4348L22.6715 12.0291H24.3479L22.9917 13.0144L23.5097 14.6087L22.1535 13.6234L20.7972 14.6087L21.3153 13.0144L19.9591 12.0291H21.6355L22.1535 10.4348Z" fill="#338AF3"/>
        <path d="M22.1535 17.3914L22.6715 18.9857H24.3479L22.9917 19.971L23.5097 21.5652L22.1535 20.5799L20.7972 21.5652L21.3153 19.971L19.9591 18.9857H21.6355L22.1535 17.3914Z" fill="#338AF3"/>
        <path d="M16 13.9131L16.5181 15.5075H18.1944L16.8382 16.4927L17.3563 18.087L16 17.1016L14.6438 18.087L15.1619 16.4927L13.8057 15.5075H15.482L16 13.9131Z" fill="#338AF3"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Honduras;
